// @unocss-include
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Particles } from './particlesState.js';
import { createPortal } from 'react-dom';
import { ParticlesProvider } from './ParticleContext.js';
export function ParticleLayer({ children, noPortal, }) {
    const [particles] = useState(() => typeof window === 'undefined'
        ? null
        : new Particles({ initialPoolSize: 100 }));
    if (!particles) {
        return null;
    }
    const canvas = (_jsx("canvas", { ref: particles.setCanvas, className: "fixed inset-0 w-full h-full z-overdraw pointer-events-none" }));
    return (_jsxs(ParticlesProvider, { value: particles, children: [noPortal ? canvas : createPortal(canvas, document.body), children] }));
}
//# sourceMappingURL=ParticleLayer.js.map